export default __webpack_public_path__ + "static/beatbugs-3-c93559d02d39f9c2e5a8108ba0c16ec1.webp";